/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {Accordion , Badge , Button , Card} from 'react-bootstrap';
import homeworkStore from '../../../store/homework-store';
import Translation from '../../../store/internationalization-store.js';


export default class Summary extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({update:true});
    }

    getTypeCounter(type, homeworkTask){
        var counter = 0;
        
        for (var i =0; i < homeworkTask.length; i++) {
            if (homeworkTask[i].type == type) {
                counter++;
            }
        }

        return counter;
    }


    activites(homeworkTask){
        var body = [];
        
        for (var i =0; i < homeworkTask.length; i++) {
            if(!homeworkTask[i].games) continue;

            for (var j =0; j < homeworkTask[i].games.length; j++) { 
                var totalString = this.getTitle(homeworkTask[i].type) + 
                " | " + homeworkTask[i].title + 
                " | " + Translation.get(homeworkTask[i].games[j].title, "game");
                body.push(<Card style={{padding:"5px" , marginBottom:'5px'}}>{totalString}</Card>)
            }
        }

        return body
    }

    section(index){
        return
    }

    getTitle(type) {
        if (type == "custom" || type == "custom") {
            return Translation.get(649, "My Content");
        }

        if (type.indexOf("vocabs") > -1) {
            return Translation.get(12233, "Vocabulary");
        } else if (type == "sentences" || type == "sentence") {
            return Translation.get(12218, "Sentence");
        } else if (type == "grammar" || type == "grammars") {
            return Translation.get(100, "Grammar");
        } else if (type == "verbs" || type == "verb") {
            return Translation.get(1028, "Verb");
        }  else if (type == "exam" || type == "exams") {
            return Translation.get(12127, "Exam");
        } else {
            return "ERROR";
        }
    }

    renderSections(){
        let body = [];
        var homeworkTasks = homeworkStore.currentHomeworkTasks;

        console.log(homeworkTasks)
        if (this.props.types != undefined && homeworkTasks != undefined && homeworkTasks.length > 0) {
            body.push(
                <Card className="summary_container" style={{padding:"5px"}}>
                    <div>
                        {this.activites(homeworkTasks)}
                    </div>
                </Card>
            )
        } else {
            body.push(
                <Card body>
                    <div>
                    <Card style={{padding:"10px"}}><b>{Translation.get(12713, 'No content selected')}</b></Card>
                   </div>
                </Card>
            )
        }

        return body;
    }

    render(){
        return <div defaultActiveKey="0">

            {this.renderSections()}

        </div>
    }

}